/*
 * @forgerock/javascript-sdk
 *
 * enums.ts
 *
 * Copyright (c) 2020 ForgeRock. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["Authenticate"] = "AUTHENTICATE";
    ActionTypes["Authorize"] = "AUTHORIZE";
    ActionTypes["EndSession"] = "END_SESSION";
    ActionTypes["Logout"] = "LOGOUT";
    ActionTypes["ExchangeToken"] = "EXCHANGE_TOKEN";
    ActionTypes["RefreshToken"] = "REFRESH_TOKEN";
    ActionTypes["ResumeAuthenticate"] = "RESUME_AUTHENTICATE";
    ActionTypes["RevokeToken"] = "REVOKE_TOKEN";
    ActionTypes["StartAuthenticate"] = "START_AUTHENTICATE";
    ActionTypes["UserInfo"] = "USER_INFO";
})(ActionTypes || (ActionTypes = {}));
//# sourceMappingURL=enums.js.map